// Module
var code = `<div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'general'">
  <form name="\$ctrl.generalForm">
    <div class="form-column">

      <form-section form-title="'Product info'">
        <form-section-field field-title="'Name'">
          <input
            type="text"
            ng-model="\$ctrl.deposit.productName"
            required
            ng-minlength="1"
            ng-maxlength="64"/>
        </form-section-field>
        <form-section-field field-title="'Description'">
          <input
            type="text"
            ng-model="\$ctrl.deposit.description"
            ng-maxlength="512"/>
        </form-section-field>
        <form-section-field field-title="'Code'">
          <input
            required
            type="text"
            ng-model="\$ctrl.deposit.productTypeCode"
            minlength="1"
            maxlength="4"/>
        </form-section-field>
      </form-section>

      <form-section form-title="'Core parameters'">
        <form-section-field field-title="'Deposit group'">
          <select
            ng-model="\$ctrl.deposit.depositGroup"
            ng-options="o.value as o.label for o in \$ctrl.depositGroups"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Deposit subgroup'">
          <select
            ng-disabled="!\$ctrl.isNewDeposit"
            ng-model="\$ctrl.deposit.depositSubgroup"
            ng-options="o.value as o.label for o in \$ctrl.depositSubgroups"
            ng-change="\$ctrl.depositSubgroupChanged()"
            ng-class="{'nx-invalid': !\$ctrl.isAdvanceInterestConfigurationValid() || !\$ctrl.isInterestAndTaxConfigurationValid() || !\$ctrl.isPledgeAgreementConfigurationValid()}"
            required>
          </select>
          <help
            ng-if="!\$ctrl.isPledgeAgreementConfigurationValid()"
            title="Pledge agreement cannot be enabled if extra placements are not allowed after activation.">
          </help>
          <help ng-if="!\$ctrl.isAdvanceInterestConfigurationValid()"
                title="Advance interest on placement must have partial withdrawal, extra placement and partial placement disabled">
          </help>
          <help ng-if="!\$ctrl.isInterestAndTaxConfigurationValid()"
                title="Advance interest on placement must have interest accrual and advance withholding tax disabled">
          </help>
        </form-section-field>
        <form-section-field field-title="'BRIS reporting category'">
          <select
            ng-model="\$ctrl.deposit.brisReportingProductCategory"
            ng-options="o as o | prettyEnum for o in \$ctrl.brisTypes"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Minimum amount'">
          <cash ng-model="\$ctrl.deposit.minimalBalance"
                max="\$ctrl.deposit.maximumBalance"
                required>
          </cash>
        </form-section-field>
        <form-section-field field-title="'Maximum amount'">
          <cash required
                ng-model="\$ctrl.deposit.maximumBalance"></cash>
        </form-section-field>
        <form-section-field field-title="'Minimum term'">
          <input
            class="small-input pull-left"
            type="number"
            ng-model="\$ctrl.deposit.minimalTerm"
            ng-max="\$ctrl.deposit.maximumTerm"
            required
            min="1" max="36500"/>
          <select class="small-input pull-right" disabled>
            <option value="day">Days</option>
          </select>
        </form-section-field>
        <form-section-field field-title="'Maximum term'">
          <input
            class="small-input pull-left"
            type="number"
            ng-model="\$ctrl.deposit.maximumTerm"
            ng-min="\$ctrl.deposit.minimalTerm"
            min="1" max="36500"/>
          <select class="small-input pull-right" disabled>
            <option value="day">Days</option>
          </select>
        </form-section-field>
        <form-section-field field-title="'Keep special interest rate after rollover'">
          <select
            required
            ng-model="\$ctrl.deposit.keepSpecialInterestRateEnabled"
            boolean-options>
          </select>
        </form-section-field>
        <form-section-field field-title="'Recalculate Doc Stamp and applicable interest rate on placement/rollover date'">
          <select
            required
            ng-model="\$ctrl.deposit.recalculateDocStampAndInterestOnTermChange"
            boolean-options>
          </select>
        </form-section-field>
      </form-section>

      <form-section form-title="'Print document settings'">
        <form-section-field field-title="'Print document'">
          <select
            ng-model="\$ctrl.passbookSupported"
            ng-change="\$ctrl.passbookConfigChange()"
            ng-options="o.value as o.label for o in \$ctrl.passbookSupportOptions"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Allow withdrawal without passbook'" ng-if="\$ctrl.passbookSupported">
          <select
            ng-model="\$ctrl.passbookConfig"
            ng-options="o.value as o.label for o in \$ctrl.passbookConfigOptions"
            ng-change="\$ctrl.passbookConfigChange()"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Show passbook printing automatically after validation'"
                            ng-if="\$ctrl.passbookSupported">
          <select
            ng-model="\$ctrl.deposit.printPassbookAfterValidationSlip"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Enable passbook slip'"
                            ng-if="\$ctrl.passbookSupported">
          <select
            ng-model="\$ctrl.deposit.enablePassbookSlip"
            boolean-options
            required>
          </select>
        </form-section-field>

        <form-section-field field-title="'Auto generate certificate number'" ng-if="\$ctrl.passbookSupported == false">
          <select ng-model="\$ctrl.deposit.certificateNumberStrategy"
                  ng-options="s.value as s.label for s in \$ctrl.certificateNumberGenerationStrategy"
                  ng-required="true">
          </select>
        </form-section-field>
        <form-section-field field-title="'Certificate number pattern'"
                            ng-if="\$ctrl.passbookSupported == false && \$ctrl.deposit.certificateNumberStrategy === 'AUTOMATIC'">
          <number-pattern ng-model="\$ctrl.deposit.certificateNumberPattern"
                                 options="\$ctrl.certificateNumberGenerationOptions"
                                 required
          >
          </number-pattern>
        </form-section-field>
      </form-section>


      <form-section form-title="'Basic interest settings'">
        <form-section-field field-title="'Divisor - days in year'">
          <select
            ng-model="\$ctrl.deposit.daysInYear"
            ng-options="o for o in \$ctrl.daysInYearOptions"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'If term higher than divisor use divisor higher or equal term'"
                            ng-if="\$ctrl.deposit.daysInYear !== \$ctrl.maxDaysInYearOption">
          <select
            ng-model="\$ctrl.deposit.useDivisorHigherOrEqualToTerm"
            boolean-options
            required>
          </select>
        </form-section-field>

        <form-section-field field-title="'Deduct credited interest on Pretermination'">
          <select
            required
            ng-model="\$ctrl.deposit.deductCreditedInterestOnPretermination"
            boolean-options>
          </select>
        </form-section-field>
      </form-section>

      <form-section form-title="'Interest accrual settings'">
        <form-section-field field-title="'Interest accrual'">
          <select
            disabled
            required
            ng-model="\$ctrl.deposit.accrualEnabled"
            boolean-options>
          </select>
        </form-section-field>
        <form-section-field field-title="'Accrue'" ng-if="\$ctrl.deposit.accrualEnabled">
          <select
            required
            ng-model="\$ctrl.deposit.accrualCycleType"
            ng-disabled="!\$ctrl.isNewDeposit && \$ctrl.deposit.termCalculationMethod === 'INTERVAL'"
            ng-options="o.value as o.label for o in \$ctrl.cycleTypes">
          </select>
        </form-section-field>
      </form-section>
      <form-section-field field-title="'Term calculation'">
        <select
          ng-class="{'nx-invalid': !\$ctrl.isTermCalculationConfigValid()}"
          ng-model="\$ctrl.deposit.termCalculationMethod"
          ng-options="o.value as o.label for o in [{ label: 'Based on interval', value: 'INTERVAL' }, { label: 'Based on exact days', value: 'EXACT_DAYS' }]"
          required
        >
        </select>
        <help ng-if="!\$ctrl.isTermCalculationConfigValid()"
              title="Interval term calculation method can only have one active accrual or crediting scheduler">
      </form-section-field>
    </div>
    <div class="form-column">
      <form-section form-title="'Tax'">
        <form-section-field field-title="'Collect withholding tax in advance?'">
          <select
            ng-model="\$ctrl.deposit.collectAdvanceWithholdingTax"
            required
            boolean-options>
          </select>
        </form-section-field>
        <form-section-field field-title="'Tax will be exempted for term longer than'">
          <glue-container append="'days'">
            <input type="number"
                   min="1"
                   max="36500"
                   ng-model="\$ctrl.deposit.taxExemptionThreshold"/>
          </glue-container>
        </form-section-field>
        <form-section-field field-title="'Enforce withholding tax calculation for overmature deposits?'">
          <select
            ng-model="\$ctrl.deposit.overmatureWtaxCalculationEnforced"
            boolean-options
            required>
          </select>
        </form-section-field>
      </form-section>

      <form-section form-title="'Placement'">
        <form-section-field field-title="'Require full initial deposit in one transaction'">
          <select
            required
            ng-class="{'nx-invalid': !\$ctrl.isPlacementConfigurationValid()}"
            ng-model="\$ctrl.deposit.partialInitialPlacementAllowed"
            ng-options='o.value as o.label for o in [{ label: "No", value: true }, { label: "Yes", value: false }]'>
          </select>
          <help ng-if="!\$ctrl.isPlacementConfigurationValid()"
            title="Pledge agreements require full initial deposits">
          </help>
        </form-section-field>
        <form-section-field field-title="'Extra placement allowed'">
          <select
            ng-class="{'nx-invalid': !\$ctrl.isPledgeAgreementConfigurationValid()}"
            ng-model="\$ctrl.deposit.placementStrategy"
            ng-options=" o.value as o.label for o in \$ctrl.placementStrategies"
            required>
          </select>
        </form-section-field>
      </form-section>

      <form-section form-title="'Partial withdrawal'">
        <form-section-field field-title="'Partial withdrawal allowed'">
          <select
            required
            ng-model="\$ctrl.deposit.partialWithdrawalAllowed"
            boolean-options>
          </select>
        </form-section-field>
      </form-section>

      <form-section form-title="'On maturity actions available'">
        <form-section-field field-title="'On maturity actions customer can choose'">
          <multiselect
            ng-required="true"
            items="\$ctrl.maturityStrategyOptions"
            ng-model="\$ctrl.deposit.maturityStrategies">
          </multiselect>
        </form-section-field>
      </form-section>

      <form-section form-title="'Interest crediting before maturity'">
        <form-section-field field-title="'Interests withdrawal before maturity'">
          <select
            ng-model="\$ctrl.creditingStrategiesValue"
            ng-change="\$ctrl.onCreditingInterestsChange()"
            ng-options="o.model as o.label for o in \$ctrl.creditingStrategies"
            required>
          </select>
          </help>
        </form-section-field>
        <form-section-field
          field-title="'Customer can withdraw&nbsp;by'"
          ng-if="\$ctrl.creditingStrategiesValue">
          <multiselect
            items="\$ctrl.creditingStrategyOptions"
            ng-model="\$ctrl.deposit.creditingStrategies"
            validate="\$ctrl.isCreditingStrategyConfigurationValid"
            ng-required="\$ctrl.creditingStrategiesValue">
          </multiselect>
          <help ng-if="!\$ctrl.isCreditingStrategyConfigurationValid()"
                title="Only pledge agreements can use 'Compounded to principal' crediting strategy">
        </form-section-field>
        <form-section-field
          field-title="'Allow transfer to related people accounts'"
          ng-if="\$ctrl.transferCreditingStrategyEnabled()">
          <select
            ng-model="\$ctrl.deposit.interCustomerTransferAllowed"
            boolean-options></select>
        </form-section-field>
      </form-section>

      <form-section form-title="'Product management'">
        <product-availability branches-to-select="\$ctrl.branches"
                              product-availability="\$ctrl.deposit.productAvailability"
                              available-in-branch-ids="\$ctrl.deposit.availableInBranchIds"></product-availability>
        <form-section-field field-title="'Allow product creation by agents'">
          <select
            ng-model="\$ctrl.deposit.allowCreationByAgents"
            boolean-options
            disabled
            required>
          </select>
        </form-section-field>
        <customer-type-constraint
          customer-type-constraints="\$ctrl.deposit.customerTypeConstraints">
        </customer-type-constraint>
        <form-section-field field-title="'Product already expired?'">
          <select
            ng-model="\$ctrl.deposit.expired"
            boolean-options
            ng-disabled="\$ctrl.isNewDeposit"
            required>
          </select>
        </form-section-field>
      </form-section>
    </div>

    <validator condition="\$ctrl.isPledgeAgreementConfigurationValid()"></validator>
    <validator condition="\$ctrl.isPlacementConfigurationValid()"></validator>
    <validator condition="\$ctrl.isAdvanceInterestConfigurationValid()"></validator>
    <validator condition="\$ctrl.isTermCalculationConfigValid()"></validator>
    <validator condition="\$ctrl.isInterestCalculationBasisValid()"></validator>

    <div class="form-column" ng-if="\$ctrl.deposit.depositSubgroup === 'PLEDGE'">
      <form-section form-title="'Pledge agreement'">
        <form-section-field field-title="'Calculate pledge amount'">
          <select
            ng-required="true"
            ng-model="\$ctrl.deposit.pledgeAmountCalculationType"
            ng-options="o.value as o.label for o in \$ctrl.pledgeAmountCalculationTypes">
          </select>
        </form-section-field>
        <form-section-field field-title="'Initial placement type'">
          <select
            ng-required="true"
            ng-model="\$ctrl.deposit.initialPlacementType"
            ng-options="o.value as o.label for o in \$ctrl.initialPlacementTypes">
          </select>
        </form-section-field>
        <form-section-field field-title="'Advanced deposit behavior:'">
          <select
            ng-required="true"
            ng-model="\$ctrl.deposit.advancePlacementType"
            ng-options="o.value as o.label for o in \$ctrl.advancePlacementTypes">
          </select>
        </form-section-field>
        <form-section-field field-title="'Grace period (days):'">
          <input
            class="small-input pull-left"
            min="0"
            ng-max="\$ctrl.maxIntegerValue"
            ng-model="\$ctrl.deposit.pledgeGracePeriodDays"
            required
            type="number"
          />
        </form-section-field>
        <form-section-field field-title="'Calculate interest based on:'">
          <select
            ng-model="\$ctrl.deposit.interestCalculationBasis"
            ng-options="o.value as o.label for o in \$ctrl.interestCalculationStrategies"
            ng-class="{'nx-invalid': !\$ctrl.isInterestCalculationBasisValid()}"
            required>
          </select>
          <help
            ng-if="!\$ctrl.isInterestCalculationBasisValid()"
            title="Initial placement type must be set to First pledge amount or On creation date, accrual cycle must be either Month / Month end only and withholding tax rate must be 0">
          </help>
        </form-section-field>
        <form-section-field field-title="'Apply overmature rate on missed deposit'">
          <select
            ng-model="\$ctrl.deposit.applyOvermatureInterestRateOnMissedPaymentEnabled"
            boolean-options
            required>
          </select>
          <help title="This will force to use the overmature interest rate once missed payment is detected, includes pledge grace period days"></help>
        </form-section-field>
      </form-section>
    </div>
  </form>
</div>

<div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'charges'">
  <form name="\$ctrl.chargesForm">
    <term-deposit-fees ng-if="\$ctrl.deposit" form="\$ctrl.chargesForm"
                       deposit="\$ctrl.deposit">
    </term-deposit-fees>
  </form>
</div>


<div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'advanced'">
  <form name="\$ctrl.advancedForm">
    <term-deposit-advanced
      ng-if="\$ctrl.deposit"
      form="\$ctrl.advancedForm"
      deposit="\$ctrl.deposit">
    </term-deposit-advanced>
  </form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/term-deposit/section/term-deposit-section.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;